import * as S from "./styles";

import radar from "assets/radar2.svg";
import PeoplesSafe from "assets/SidebarIcons/orange-peoplesafeone.svg";

import left from "assets/left.svg";

import { WorkNotification } from "interfaces/Notification";
import { useNotifications } from "contexts/notificationContext";

type Props = {
  notification: WorkNotification;
};

export default function Notification({ notification }: Props) {
  const { seeNotification } = useNotifications();

  function onHover() {
    seeNotification(notification);
  }

  const image = notification.type === "occurrence" ? radar : PeoplesSafe;

  return (
    <S.StyledLink
      to="/monitor"
      onMouseEnter={() => {
        onHover();
      }}
      className={notification.saw ? "seen" : "unseen"}
    >
      <S.Container>
        <S.ImgContainer>
          <img src={image} alt="Ícone da notificação" />
        </S.ImgContainer>

        <p>{notification.message}</p>
      </S.Container>

      <S.ImgLeft src={left} alt="Seta para a direita, indicando link" />
    </S.StyledLink>
  );
}
